module.exports = __webpack_public_path__ + "static/media/send.5d0dc7e5.svg";